var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFreeIcon = function SvgFreeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 35,
    fill: "none",
    viewBox: "0 0 50 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4553a9",
    stroke: "#4553a9",
    strokeLinejoin: "round",
    d: "M8.169 4.7v5.552H3.494l1.87 5.243L1 17.963l4.364 2.775-2.494 4.318h5.61v4.935l5.3-2.16.934 5.244 4.987-3.393L21.571 34l3.74-4.318L28.43 34l2.805-4.318 4.363 3.393.935-5.243 4.988 1.85v-4.626h5.61l-2.494-4.318L49 17.963l-4.364-3.701 1.87-4.01h-5.298V5.626l-4.675 1.85-1.247-4.934-4.676 3.701L28.43 1l-3.74 4.626L21.57 1l-3.117 4.626-3.74-3.084-1.558 5.551z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.622 22H10v-9h5.961v1.434h-4.339v2.527h3.893v1.409h-3.893zM22.562 22l-2.014-3.554h-1.19V22h-1.635v-9H21.4c1.852 0 3 1.206 3 2.73 0 1.281-.824 2.259-2.162 2.563L24.4 22zm-3.204-4.9h1.744c1 0 1.65-.546 1.65-1.37 0-.839-.65-1.384-1.65-1.384h-1.744zM32.158 22h-5.92v-9h5.92v1.422H27.86v2.386h3.893v1.384H27.86v2.386h4.298zM40 22h-5.92v-9H40v1.422h-4.299v2.386h3.893v1.384h-3.893v2.386H40z"
  })));
};
export { SvgFreeIcon as Icon };
export default __webpack_public_path__ + "static/media/c569068a6cff71ad0eeb4ef9c409e957.svg";